import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const OrderContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  background-color: ${COLORS.bgWhite};
`

export const ProgressBarSection = styled.div`
  flex: 0 0 auto;
  background-color: ${COLORS.bgWhite};
`

export const OrderScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 24px 0;
`

export const OrderHeadingSection = styled.section`
  padding: 16px 24px 12px;
`

export const OrderHeading = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: -0.36px;
  color: ${COLORS.textPrimary};
`

export const OrderSubheading = styled.p`
  margin: 12px 0 0;
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.textSecondary};
`

export const OrderProductSection = styled.section`
  padding: 0 16px;
`

export const OrderSummarySection = styled.section`
  padding: 0 16px;
`

export const OrderBottomBar = styled.div`
  flex: 0 0 auto;
  padding: 12px 16px calc(8px + var(--safe-bottom, 0px));
  background-color: ${COLORS.bgWhite};
`
